/**
 * Sandy Resort — Site Theme
 * ─────────────────────────
 * All brand colors, typography, and identity tokens live here.
 * Change this file to experiment with different theme directions.
 */

export const siteTheme = {
  // ── Brand Identity ───────────────────────────────────────────────────────
  name:          'Sandy Resort',
  tagline:       'Luxury Beach Retreat',
  location:      'Kovalam Village, Kanyakumari, Tamil Nadu, India',
  phone:         '+91 96268 04925',
  email:         'reservations@sandyresort.in',
  instagram:     '@sandyresort',

  // ── Color Palette ────────────────────────────────────────────────────────
  // Values are CSS variables — defaults live in globals.css :root
  // CMS overrides are injected as a <style> tag in layout.tsx
  colors: {
    navyDeep:    'var(--navy-deep)',
    navyMid:     'var(--navy-mid)',
    navyCta:     'var(--navy-cta)',
    gold:        'var(--gold)',
    goldLight:   'var(--gold-light)',
    goldPale:    'var(--gold-pale)',
    goldDark:    'var(--gold-dark)',
    goldDeep:    'var(--gold-deep)',
    bg:          'var(--bg)',
    bgAlt:       'var(--bg-alt)',
    white:       '#FFFFFF',
    black:       '#000000',
    grey:       'var(--grey)',
    green:      'var(--green)',
  },

  // ── Typography ───────────────────────────────────────────────────────────
  // Values are CSS variables — defaults in globals.css, overridden by CMS
  fonts: {
    serif:  'var(--font-serif)',
    sans:   'var(--font-sans)',
    script: 'var(--font-script)',
  },

  // ── Navigation Links ─────────────────────────────────────────────────────
  navLinks: [
    { label: 'Rooms & Suites',  href: '/rooms' },
    { label: 'Gastronomy',      href: '/gastronomy' },
    { label: 'Experiences',     href: '/experiences' },
    { label: 'Destination',     href: '/destination' },
    { label: 'Spa & Wellness',  href: '/amenities' },
    { label: 'Gallery',         href: '/gallery' },
    { label: 'About',           href: '/about' },
    { label: 'Contact',         href: '/contact' },
  ],
} as const;

export type SiteTheme = typeof siteTheme;
export default siteTheme;
